import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';
import AppBar from '@material-ui/core/AppBar';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import ClearIcon from '@material-ui/icons/Clear';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import RefreshIcon from '@material-ui/icons/Refresh';
import HelpIcon from '@material-ui/icons/HelpOutline';
import SaveIcon from '@material-ui/icons/Save';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewMapIcon from '@material-ui/icons/Map';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import common from '@material-ui/core/colors/common';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import { darkTheme, lightTheme } from '../../themes';
import { orderedColors } from '../../helpers/schedules-colors';

const exampleAddress = {
  createdAt: '2000-01-01 00:00:00',
  updatedAt: '2000-01-01 00:00:00',
  uuid: '000000002',
  type: 'delivery',
  date: '2018-10-01',
  order: 10,
  schedule: 'SCHEDULE_1400',
  street: 'Carrer Miguel Hernández, 23',
  door: '',
  postalCode: '08908',
  locality: 'L\'Hospitalet de Llobregat',
  administrativeArea: 'Barcelona',
  country: 'ES',
  other: '',
  location: {
    type: 'Point',
    coordinates: [2.125034, 41.349198],
  },
  locationPrecision: 'serviceRooftop',
  placeId: 'ChIJz9Pd-smYpBIRYHYPoYWswQA',
  publicEditing: {
    hash: '93cb8c1b-4646-48cc-9276-aed478cc3a9d',
    visible: true,
    editable: true,
  },
  tags: [],
};

class ExampleCell extends Component {
  render() {
    const { t, address: { order, street, schedule } } = this.props;
    const contentStyle = { boxSizing: 'content-box', margin: '16px 0', backgroundColor: common.white, border: `1px solid ${grey[400]}` };
    const draggableStyle = { padding: '4px 0' };
    const orderStyle = { flexShrink: 0, width: '64px' };
    const textStyle = { flexGrow: 1 };
    const scheduleStyle = { color: orderedColors[schedule] };
    const leftButtonStyle = { flexShrink: 0, padding: '4px 0' };
    const rightButtonStyle = { flexShrink: 0, padding: '4px 4px 4px 0' };
    return (
      <Grid container item wrap="nowrap" alignItems="center" style={contentStyle}>
        <Grid container item wrap="nowrap" alignItems="center" style={draggableStyle}>
          <Grid item style={orderStyle}>
            <Typography variant="h6" align="center">
              <Badge color="error" badgeContent={1}>
                {order}
              </Badge>
            </Typography>
          </Grid>
          <Grid item style={textStyle}>
            <Typography variant="body2">
              {street}<br/><span style={scheduleStyle}>{t(`schedules.${schedule}`)}</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid item style={leftButtonStyle}>
          <Tooltip title={t('buttons.editLocationInAnotherWindow')}>
            <Badge color="error" badgeContent={2}>
              <IconButton>
                <EditLocationIcon/>
              </IconButton>
            </Badge>
          </Tooltip>
        </Grid>
        <Grid item style={rightButtonStyle}>
          <Tooltip title={t('buttons.delete')}>
            <Badge color="error" badgeContent={3}>
              <IconButton>
                <ClearIcon nativeColor={red[700]}/>
              </IconButton>
            </Badge>
          </Tooltip>
        </Grid>
      </Grid>
    );
  }
}

ExampleCell.propTypes = {
  t: PropTypes.func.isRequired,
  address: PropTypes.object,
};

const WrappedExampleCell = withNamespaces()(ExampleCell);

class EmptyCell extends Component {
  render() {
    const { t } = this.props;
    const outerStyle = { padding: '4px', backgroundColor: grey[200] };
    const innerStyle = { padding: '8px', backgroundColor: grey[200], border: `2px dashed ${grey[400]}` };
    return (
      <Grid item container direction="column" style={outerStyle}>
        <Grid item style={innerStyle}>
          <Typography variant="body2" align="center">{t('messages.addToList')}</Typography>
          <Typography variant="body2" align="center">{t('messages.moveAddToList')}</Typography>
        </Grid>
      </Grid>
    );
  }
}

EmptyCell.propTypes = { t: PropTypes.func.isRequired };

const WrappedEmptyCell = withNamespaces()(EmptyCell);

class NavigationBar extends Component {
  render() {
    const { t } = this.props;
    return (
      <div style={{ padding: '0 0 16px' }}>
        <MuiThemeProvider theme={darkTheme}>
          <AppBar position="static">
            <div style={{ padding: 4 }}>
              <Grid container alignItems="center" wrap="nowrap">
                <Grid item style={{ flexGrow: 1 }}/>
                <Grid item style={{ flexShrink: 0 }}>
                  <Tooltip title={t('buttons.reloadRoute')}>
                    <IconButton>
                      <RefreshIcon/>
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item style={{ flexShrink: 0 }}>
                  <Tooltip title={t('buttons.help')}>
                    <IconButton>
                      <HelpIcon/>
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item style={{ flexShrink: 0 }}>
                  <Tooltip title={t('buttons.save')}>
                    <IconButton>
                      <SaveIcon/>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </div>
          </AppBar>
        </MuiThemeProvider>
      </div>
    );
  }
}

NavigationBar.propTypes = { t: PropTypes.func.isRequired };

const WrappedNavigationBar = withNamespaces()(NavigationBar);

class HelpDialog extends Component {
  render() {
    const { t, fullScreen, open, onClose } = this.props;
    const subtitleStyle = { margin: '32px 0 16px', borderBottom: '1px solid rgba(0, 0, 0, 0.87)' };
    const bodyStyle = { margin: '16px 0' };
    const listItemStyle = { padding: '10px 0' };
    return (
      <MuiThemeProvider theme={lightTheme}>
        <Dialog fullScreen={fullScreen} open={open} onClose={onClose} scroll="paper">
          <DialogContent>
            <Typography variant="h5">{t('help.title')}</Typography>
            <Typography variant="h6" style={subtitleStyle}>{t('help.navigationBar.title')}</Typography>
            <Typography variant="body1" style={bodyStyle}>{t('help.navigationBar.description')}</Typography>
            <WrappedNavigationBar/>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <RefreshIcon/>
              </ListItemIcon>
              <ListItemText primary={t('help.navigationBar.reload')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <HelpIcon/>
              </ListItemIcon>
              <ListItemText primary={t('help.navigationBar.help')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <SaveIcon/>
              </ListItemIcon>
              <ListItemText primary={t('help.navigationBar.save')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <MoreVertIcon/>
              </ListItemIcon>
              <ListItemText primary={t('help.navigationBar.more')} secondary={t('help.navigationBar.onlyOnMobile')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <ViewListIcon/>
              </ListItemIcon>
              <ListItemText primary={t('help.navigationBar.viewList')} secondary={t('help.navigationBar.onlyOnMobile')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <ViewMapIcon/>
              </ListItemIcon>
              <ListItemText primary={t('help.navigationBar.viewMap')} secondary={t('help.navigationBar.onlyOnMobile')}/>
            </ListItem>
            <Typography variant="h6" style={subtitleStyle}>{t('help.map.title')}</Typography>
            <Typography variant="body1" style={bodyStyle}>{t('help.map.types.title')}</Typography>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="50px" style={{ padding: '10px' }} src="/images/help/unordered_address.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.types.unorderedAddress')} secondary={t('help.map.types.clickToOrderAddress')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="50px" style={{ padding: '10px' }} src="/images/help/ordered_address.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.types.orderedAddress')} secondary={t('help.map.types.clickToUnorderAddress')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="50px" src="/images/help/unordered_cluster.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.types.unorderedCluster')} secondary={t('help.map.types.clickToOrderCluster')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="50px" src="/images/help/ordered_cluster.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.types.orderedCluster')} secondary={t('help.map.types.clickToUnorderCluster')}/>
            </ListItem>
            <Typography variant="body1" style={bodyStyle}>{t('help.map.colors.title')}</Typography>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="70px" src="/images/help/early_morning.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.colors.earlyMorning')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="70px" src="/images/help/morning.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.colors.morning')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="70px" src="/images/help/noon.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.colors.noon')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <img width="70px" src="/images/help/all_day.svg" alt=""/>
              </ListItemIcon>
              <ListItemText primary={t('help.map.colors.allDay')}/>
            </ListItem>
            <Typography variant="body1" style={bodyStyle}>{t('help.map.controls.title')}</Typography>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <Grid container justify="center" wrap="nowrap" style={{ minWidth: '110px' }}>
                  <Grid item>
                    <Button variant="contained" size="small" style={{ backgroundColor: 'white' }}>
                      <VisibilityIcon style={{ marginRight: '8px' }}/>
                      {t('mapFilter.ALL', { count: 100 })}
                    </Button>
                  </Grid>
                </Grid>
              </ListItemIcon>
              <ListItemText primary={t('help.map.controls.filter')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <Grid container justify="center" wrap="nowrap" style={{ minWidth: '110px' }}>
                  <Grid item>
                    <Button variant="contained" size="small" style={{ minWidth: 0, backgroundColor: 'white' }}>
                      <ZoomOutMapIcon/>
                    </Button>
                  </Grid>
                </Grid>
              </ListItemIcon>
              <ListItemText primary={t('help.map.controls.zoom')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <Grid container justify="center" wrap="nowrap" style={{ minWidth: '110px' }}>
                  <Grid item>
                    <img width="30px" style={{ marginRight: '16px' }} src="/images/help/unordered_address.svg" alt=""/>
                  </Grid>
                  <Grid item style={{ margin: '15px 0 0 -30px' }}>
                    <Paper>
                      <Typography variant="body1" align="center" style={{ fontStyle: 'italic', padding: '4px 8px' }}>
                        {t('help.map.controls.menu')}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </ListItemIcon>
              <ListItemText primary={t('help.map.controls.contextMenu')}/>
            </ListItem>
            <Typography variant="h6" style={subtitleStyle}>{t('help.list.title')}</Typography>
            <Typography variant="body1" style={bodyStyle}>{t('help.list.item')}</Typography>
            <WrappedExampleCell address={exampleAddress}/>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <Badge color="error" badgeContent={1} style={{ marginBottom: '-36px' }}>
                  <img width="12px" src="/images/help/transparent.svg" alt="" style={{ padding: '12px' }}/>
                </Badge>
              </ListItemIcon>
              <ListItemText primary={t('help.list.order')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <Badge color="error" badgeContent={2} style={{ marginBottom: '-36px' }}>
                  <img width="12px" src="/images/help/transparent.svg" alt="" style={{ padding: '12px' }}/>
                </Badge>
              </ListItemIcon>
              <ListItemText primary={t('help.list.geocorrect')}/>
            </ListItem>
            <ListItem style={listItemStyle}>
              <ListItemIcon>
                <Badge color="error" badgeContent={3} style={{ marginBottom: '-36px' }}>
                  <img width="12px" src="/images/help/transparent.svg" alt="" style={{ padding: '12px' }}/>
                </Badge>
              </ListItemIcon>
              <ListItemText primary={t('help.list.remove')}/>
            </ListItem>
            <Typography variant="body1" style={bodyStyle}>{t('help.list.emptyItem')}</Typography>
            <WrappedEmptyCell/>
          </DialogContent>
          <DialogActions>
            <Button color="inherit" onClick={onClose}>{t('buttons.ok')}</Button>
          </DialogActions>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

HelpDialog.propTypes = {
  t: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withNamespaces()(withMobileDialog()(HelpDialog));



// WEBPACK FOOTER //
// ./src/components/dialogs/HelpDialog.js